/**
 * Facts quoted on the public site. Keep them true: update together with the workspace catalog
 * (plugins/standard/standard-plugin-modules.ts). Not computed from the registry on purpose,
 * so the public bundle does not pull in every tool module.
 */
export const WORKSPACE_TOOL_COUNT = 28;

/** Usual time to approve a new account, as promised on the login page and in the terms. */
export const ACCOUNT_APPROVAL_TIME = '1 giorno lavorativo';

export const SITE_URL = 'https://www.semplora.it';
export const CONTACT_EMAIL = 'info@semplora.it';

/** Legal identity shown in the footer and in the legal pages (art. 2250 c.c., art. 35 DPR 633/72). */
export const COMPANY = {
    name: 'Nauka Team S.r.l.',
    vatNumber: '06853320965',
    address: 'Via Valtellina 18, Milano',
    rea: '1919743',
    // non-breaking space: the amount never wraps away from the currency sign
    shareCapital: '€ 10.000 i.v.',
};
